import {Cancel, CheckCircle} from '@mui/icons-material';
import {Alert, Typography} from '@mui/material';
import {SessionQuestion} from '@cp/model';
import MarkdownContentRenderer from '../../atoms/MarkdownContentRenderer/MarkdownContentRenderer';

export interface SessionFeedbackProps {
  selectedAnswer: string;
  currentQuestion: SessionQuestion;
  /**
   * If showFeedback is true, the feedback will be shown regardless of the currentQuestion.selectedAnswer.
   * when showFeedback is undefined, the feedback will be shown if the currentQuestion.selectedAnswer is not undefined.
   * @default undefined
   */
  showFeedback?: boolean;
}

export default function SessionFeedback({currentQuestion, showFeedback, selectedAnswer}: SessionFeedbackProps) {
  const shouldShow = showFeedback !== undefined ? showFeedback : !!currentQuestion.selectedAnswer;
  if (!shouldShow) return null;

  const isCorrect = currentQuestion.isCorrect ?? selectedAnswer === currentQuestion.answer;
  return (
    <Alert
      severity={isCorrect ? 'success' : 'error'}
      icon={isCorrect ? <CheckCircle /> : <Cancel />}
      data-testid={isCorrect ? 'correct-indicator' : 'incorrect-indicator'}
    >
      <Typography variant="body1" sx={{fontWeight: 600, mb: 1}}>
        {isCorrect ? 'Correct!' : 'Incorrect'}
      </Typography>
      {currentQuestion.explanation && <MarkdownContentRenderer content={currentQuestion.explanation} />}
    </Alert>
  );
}
